import "../css/connections.css";
import "../css/button.css";
import "../css/module.css";
import commoncss from "../css/common.module.css"
import { useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import ModuleCard from "../elements/ModuleCard";
import ModuleHeader from "../elements/ModuleHeader";
import Tabs from "../elements/Tabs";

export default function ModulesLibrary() {
  const [activeTab, setActiveTab] = useState("Investments");

  const tabs = ["Investments", "Leases", "Loans", "Payables", "Receivables"];

  const breadcrumbItems = [
    {
      label: "Workspace name",
      link: "/myfinv2/book-closure",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Book closure name",
      link: "/myfinv2/",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Import tasks from Library", link: "", className: "headerLable" },
  ];

  const cardsData = new Array(10).fill({
    title: "Compute current and non-current split of lease liability",
    description:
      "Compute short term lease liabilities to update presentation as per Schedule III",
  });

  const toggleItems = [
    {label: "Templates" ,status: false,onToggle: () => {}},
  ]

  return (
    <>
      <div className="connections-wrapper bgClr1">
        <Breadcrumb
          addCls={"bgClr1"}
          items={breadcrumbItems}
          headerActions={<></>}
        />
        <div className="library-container">
          <ModuleHeader />
          <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
          <div className="modulecards-grid">
            {cardsData.map((card, index) => (
              <ModuleCard
                key={index}
                title={card.title}
                description={card.description}
                toggles={toggleItems}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
